// drawer/tabs/OverviewTab.tsx
import {
  CVSSComponent,
  EPSSComponent,
} from '@/sections/threats/drawer/components';
import type { EnrichedVulnerability } from '@/sections/threats/types';

interface OverviewTabProps {
  threatIntel?: EnrichedVulnerability;
}

/**
 * Overview tab content - description, EPSS, and CVSS scores
 */
export function OverviewTab({ threatIntel }: OverviewTabProps) {
  const description = threatIntel?.description || '';

  return (
    <>
      <h3 className="text-chariot-text-primary text-sm">{description}</h3>
      <EPSSComponent threatIntel={threatIntel} />
      <CVSSComponent threatIntel={threatIntel} />
    </>
  );
}
